<template>
  <div ref="activities" class="scenario-activity">
    <h2 class="title">
      {{ $t('LISTEN.SPACIAL_ACTIVITY') }}
    </h2>
    <div class="list">
      <RouterLink v-for="(item, index) in activityList" :key="index" :aria-label="item.subject"
                  :to="{ name: 'scenarioById', params: { locale: $i18n.localePath(), id: item.id}}" class="item"
      >
        <div v-cover-lazy-loader :data-src="item.cover" :data-default-src="'/img/cover-social/listen.png'" class="cover">
          <!--  -->
        </div>
        <div class="subject">
          {{ item.subject }}
        </div>
        <div class="description">
          {{ item.description }}
        </div>
      </RouterLink>
    </div>
  </div>
</template>

<script>
import CoverLazyLoader from '@/directives/CoverLazyLoader'
export default {
  name: 'ListenScenarioActivity',
  components: {},
  directives: {
    CoverLazyLoader
  },
  props: {},
  data() {
    return {
      activityList: [
        {
          id: '8f7316cf-2fd0-4c9d-94f8-6734d07c1d5e',
          subject: '⾙多芬九⾸交響曲',
          description: '貝多芬的交響作品，從第一號到第九號《合唱》，帶我們經歷峰迴路轉，聽見他失聰後更為絢爛的世界！',
          cover: '/img/listen/activity/activity_Beethoven_Symphony.jpg'
        },
        {
          id: '8bab936e-d25b-4035-aca0-52b90b90766c',
          subject: '貝多芬鋼琴奏鳴曲全集',
          description: '貝多芬的聲音始終縈繞在我們耳畔，而最能貫穿他各期創作歷程，當非這32首鋼琴奏鳴曲莫屬。跟著MUZIK的腳步，利用8天的時間，聆賞貝多芬全套鋼琴奏鳴曲。',
          cover: '/img/listen/activity/activity_Beethoven_Sonata.jpg'
        },
        {
          id: '8f7317b0-584e-479d-a3b9-6177f218388e',
          subject: '⾙多芬室內樂集',
          description: '貝多芬的室內樂作品與《32首鋼琴奏鳴曲》一樣，同樣是跨越生命之作。特別是弦樂四重奏，某程度上貫穿了他的心靈層面。',
          cover: '/img/listen/activity/activity_Beethoven_Chamber_Music.jpg'
        },
        {
          id: '8bab9346-7ee9-4f64-b44b-b6ea0d5f35d8',
          subject: '古典樂名曲 究極100',
          description: '《MUZIK》推出「古典樂名曲　究極100」企劃主題，這份曲單不會只是一份「金曲榜單」，我們先以「樂種」分出古典音樂的10個類別，並用歷史的縱觀概念，找出10首具有「承先啟後」性質的代表作，力求凸顯出音樂史上的「完整性」，並期待大家從中發現自己喜愛的作品時，能夠「順藤摸瓜」，找出這些曲子後所能延伸的眾多曲目，是為「延續性」。能夠符合這兩者的「古典樂名曲」，才符合本次的「究極」條件。',
          cover: '/img/listen/activity/activity_Classical_Music_Masterpieces_THE_ULTIMATE_990x480.jpg'
        },
        {
          id: '8bab9355-25b7-4450-8285-9eb82e1f087d',
          subject: '古典樂刊',
          description: '用左手翻開音樂時事：近期表演活動、樂界新聞動態、最新唱片評析等。用右手打開古典知識：以「當月音樂家」作為主軸，介紹史上偉大作曲家、音樂家的深入訪談、樂界近期重點現象、名家專欄、樂界趣聞等。附贈當月音樂家之精選作品唱片，讓大家「看」的精采，「聽」的過癮！',
          cover: '/img/listen/activity/activity_MUZIK.jpg'
        },
        {
          id: '8bab932e-c174-4b58-ba22-9cfb5c236681',
          subject: '有樂出版',
          description: '有樂出版是MUZIK事業群旗下專門出版音樂刊物的公司，除了大家所熟悉的《MUZIK古典樂刊》之外，還有各種與音樂相關的出版書籍，目的在豐富國內古典音樂的知識面向，進一步推展豐富台灣古典音樂領域。',
          cover: '/img/listen/activity/activity_art.png'
        }
      ]
    }
  },
  created() {
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    activityCover(item) {
      return { 'background-image': `url(${item.cover})` }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.title {
  margin: 16px 0;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.63;
  letter-spacing: normal;
  color: $grey-50;
}
.list {
  display: block;
  margin: 0 -23px;
  .item {
    position: relative;
    width: calc(33.33% - 46px);
    display: inline-block;
    vertical-align: top;
    margin: 0 23px;
    text-decoration: none;
    cursor: pointer;
    .cover {
      width: 100%;
      padding-top: 42%;
      border-radius: 12px;
      border: 1px solid $grey-ec;

      background-color: $grey-ec;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
    .subject {
      height: 32px;
      width: 100%;
      margin-top: 12px;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.6;
      text-decoration: none;
      color: $grey-50;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .description {
      height: 36px;
      margin-top: 4px;
      margin-bottom: 24px;
      font-size: 12px;
      font-weight: 500;
      line-height: 1.6;
      text-decoration: none;
      color: $grey-7d;
      @include ellipsis-with-lines(2);
    }
  }
}

@media only screen and (min-width: 1440px) {
  // As default
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  //
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
}
@media only screen and (max-width: 767.98px) {
  .list {
    margin: 0;
    .item {
      width: 100%;
      margin: 0;
      .cover {
        width: 100%;
        padding-top: 42%;
      }
    }
  }
}
</style>
